const defaultCardTypes = {
  mastercard: [
    [51, 55],
    // [222100, 272099], ?
  ],
  visa: [[4]],
  mir: [[2]],
};

export default function cardtype(card, cardTypes = defaultCardTypes) {
  if (!card || typeof card !== "string") {
    return null;
  }

  let typeName = null;

  Object.keys(cardTypes).some((type) => {
    return cardTypes[type].some((optList) => {
      if (optList[1]) {
        for (let opt = optList[0]; opt <= optList[1]; opt++) {
          if (card.startsWith(opt)) {
            typeName = type;
            return true;
          }
        }
      } else if (card.startsWith(optList[0])) {
        typeName = type;
        return true;
      }
      return false;
    });
  });

  return typeName;
}



// WEBPACK FOOTER //
// ./src/components/emission/cards/Card/cardtype.js